import React, { useState, useEffect } from "react";
import { X } from "lucide-react";

const FloatingWidget = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [opacity, setOpacity] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const rotationSpeed = 80;
  const fadeInDuration = 1500;

  // Recursos de imágenes
  const rotatingImage =
    "https://vacewaenygdaqchlrsam.supabase.co/storage/v1/object/public/web-landing/hablemos-por-whatsapp-item-01-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.svg";
  const staticImage =
    "https://vacewaenygdaqchlrsam.supabase.co/storage/v1/object/public/web-landing/hablemos-por-whatsapp-item-02-plan-recambios-botellon-20l-dispensador-pedidos-online-entrega-domicilio-agua-purificada-calidad.png";

  const phoneNumber = "573161232337";
  const message = "Hola, me gustaría obtener más información sobre los servicios de Fluenti";

  // Detectar si es dispositivo móvil
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    // Verificar al inicio
    checkMobile();
    
    // Verificar al cambiar el tamaño de la ventana
    window.addEventListener("resize", checkMobile);
    
    return () => {
      window.removeEventListener("resize", checkMobile);
    };
  }, []);

  // Animación de aparición gradual
  useEffect(() => {
    const fadeInInterval = setInterval(() => {
      setOpacity((prevOpacity) => {
        if (prevOpacity >= 1) {
          clearInterval(fadeInInterval);
          return 1;
        }
        return prevOpacity + 0.01;
      });
    }, fadeInDuration / 100);

    return () => clearInterval(fadeInInterval);
  }, []);

  // Manejar click en WhatsApp
  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  // Manejar cierre del widget
  const handleClose = (e) => {
    e.stopPropagation();
    setIsVisible(false);
  };

  if (!isVisible) return null;

  // Estilos CSS para animación de rotación


  return (
    <>
      <div 
        id=" spin-reverse"
        className="fixed z-[8888] pe-8 pb-8"
        style={{
          bottom:"0px",
          right: "0px",
          opacity,
          transition: `opacity ${fadeInDuration}ms ease-in`,
          // Estilos clave para garantizar visualización adecuada
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          // Evitar que se corte o deforme
          overflow: "visible", 
          transform: "translateZ(0)",
          willChange: "transform"
        }}
      >
        <div
          onClick={handleWhatsAppClick}
          style={{
            width: isMobile ? "160px" : "180px", 
            height: isMobile ? "160px" : "180px",
            position: "relative",
            cursor: "pointer",
            // Asegurar que mantenga su forma
            borderRadius: "50%",
            overflow: "hidden",
            // Evitar deformaciones
            transform: "translateZ(0)",
            backfaceVisibility: "hidden",
            // Decoración
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
          }}
        >
          {/* Fondo circular rotatorio */}
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              width: "100%",
              height: "100%",
              borderRadius: "50%",
              backgroundImage: `url(${rotatingImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              animation: `spin-reverse ${rotationSpeed}s linear infinite`,
              // Garantiza renderizado correcto
              transformOrigin: "center center",
              willChange: "transform"
            }}
          />
          
          {/* Logo central estático */}
          <div
            style={{
              position: "absolute",
              top: "20%",
              left: "20%",
              width: "60%",
              height: "60%",
              borderRadius: "50%",
              backgroundImage: `url(${staticImage})`,
              backgroundSize: "contain",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              zIndex: 2,
            }}
          />
        </div>
        
        {/* Botón de cierre */}
        <button
          onClick={handleClose}
          style={{
            position: "absolute",
            top: isMobile ? "-24px" : "-24px",
            right: isMobile ? "24px" : "24px",
            width: isMobile ? "24px" : "32px",
            height: isMobile ? "24px" : "32px",
            backgroundColor: "white",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
            border: "none",
            cursor: "pointer",
            zIndex: 10000,
            padding: 0
          }}
          aria-label="Cerrar chat de WhatsApp"
        >
          <X size={isMobile ? 12 : 16} />
        </button>
      </div>

    </>
  );
};

export default FloatingWidget;